export default __webpack_public_path__ + "img/shape-star-small.288ef67d.svg";